import { render, staticRenderFns } from "./commonPageNew1.vue?vue&type=template&id=76b0828f&scoped=true"
import script from "./commonPageNew1.vue?vue&type=script&lang=js"
export * from "./commonPageNew1.vue?vue&type=script&lang=js"
import style0 from "./commonPageNew1.vue?vue&type=style&index=0&id=76b0828f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b0828f",
  null
  
)

export default component.exports